import { useSyncExternalStore } from 'react';
import { today } from '../reports/reportUtils';

/* The TDS screens share one financial year (remembered in this browser), as the report period. */

/** "2026-27" for a date. */
export const fyOf = (d: string) => { const y = Number(d.slice(0, 4)), s = Number(d.slice(5, 7)) >= 4 ? y : y - 1; return `${s}-${String((s + 1) % 100).padStart(2, '0')}`; };
/** This year and the two before it. */
export const fyChoices = () => { const s = Number(fyOf(today()).slice(0, 4)); return [0, 1, 2].map((k) => `${s - k}-${String((s - k + 1) % 100).padStart(2, '0')}`); };

const KEY = 'grhamoy.acc-tds-fy';
let current = (() => { try { const v = localStorage.getItem(KEY); if (v && fyChoices().includes(v)) return v; } catch { /* private window */ } return fyOf(today()); })();
const subs = new Set<() => void>();
export function useFy(): [string, (fy: string) => void] {
  const fy = useSyncExternalStore((f) => { subs.add(f); return () => { subs.delete(f); }; }, () => current);
  return [fy, (v: string) => { current = v; try { localStorage.setItem(KEY, v); } catch { /* ignore */ } subs.forEach((f) => f()); }];
}

/** "2026-09" → "Sep-2026". */
export const monthLabel = (m: string) => (/^\d{4}-\d{2}$/.test(m) ? `${['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][Number(m.slice(5)) - 1]}-${m.slice(0, 4)}` : m);
/** Status → colour: done / due / late. */
export const statusTone = (s: string) => (/^(Issued|Matched|On time|Filed|Paid |Active|Deposited|Not yet$)/.test(s) ? 'ok' : /(Overdue|short|late|not filed|Not filed|No PAN|Exhausted|Expired|crossed)/i.test(s) ? 'bad' : 'warn');
